import { useEffect, useState } from 'react';

// The narrow band in the middle of the viewport decides which section is
// "current", so short sections still win when they cross the center.
export function useActiveSection(sectionIds) {
    const [activeId, setActiveId] = useState('');

    useEffect(() => {
        if (!sectionIds.length) return undefined;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) setActiveId(entry.target.id);
            });
        }, { rootMargin: '-45% 0px -50% 0px' });

        sectionIds.forEach((id) => {
            const node = document.getElementById(id);
            if (node) observer.observe(node);
        });
        return () => observer.disconnect();
    }, [sectionIds]);

    return activeId;
}
